import validator from 'validator';

const validpassword = (data) => {
  let errors = {}
  let regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  const { password, cpassword} = data;

 
  if(validator.isEmpty(password)) {
    errors.password =  '새 비밀번호를 입력하세요.'
  }
  if (!password.match(regularExpression)) {
    errors.password = '영문/숫자/특수문자 포함 8자 이상 16자 미만';
  }
  if(validator.isEmpty(cpassword)) {
    errors.cpassword =  '확인 비밀번호를 입력하세요.'
  }
  if (!cpassword.match(regularExpression)) {
    errors.cpassword = '영문/숫자/특수문자 포함 8자 이상 16자 미만';
  }
  return {
    isInvalid: Object.keys(errors).length > 0,
    error: errors
  }
}

export default validpassword;